export interface AppEnv {
  VITE_ASSET_SERVER: string;
  VITE_API_HOST: string;
  VITE_HOSTS_AUTHORIZATION: string;
  VITE_PLATFORM_REDIRECT: string;
  VITE_DEFAULT_REDIRECT: string;
  VITE_GREENROOM_REDIRECT: string;
  VITE_EVENTS_APP_HOST: string;
  VITE_SSO_HOST: string;
  VITE_STAGE: string;
  VITE_GREENROOM_ASSETS: string;
}

declare global {
  interface Window {
    __env?: AppEnv;
  }
}

// On the client, window.__env is injected by the server before the bundle loads (see App.tsx).
// On the server, initEnv() is called from the layout loader before child loaders run.
// Build-time import.meta.env values are a last-resort fallback only.
let _env: AppEnv = (typeof window !== 'undefined' ? window.__env : undefined) ?? {
  VITE_ASSET_SERVER: import.meta.env.VITE_ASSET_SERVER ?? '',
  VITE_API_HOST: import.meta.env.VITE_API_HOST ?? '',
  VITE_HOSTS_AUTHORIZATION: import.meta.env.VITE_HOSTS_AUTHORIZATION ?? '',
  VITE_PLATFORM_REDIRECT: import.meta.env.VITE_PLATFORM_REDIRECT ?? '',
  VITE_DEFAULT_REDIRECT: import.meta.env.VITE_DEFAULT_REDIRECT ?? '',
  VITE_GREENROOM_REDIRECT: import.meta.env.VITE_GREENROOM_REDIRECT ?? '',
  VITE_EVENTS_APP_HOST: import.meta.env.VITE_EVENTS_APP_HOST ?? '',
  VITE_SSO_HOST: import.meta.env.VITE_SSO_HOST ?? '',
  VITE_STAGE: import.meta.env.VITE_STAGE ?? '',
  VITE_GREENROOM_ASSETS: import.meta.env.VITE_GREENROOM_ASSETS ?? '',
};

export function initEnv(env: AppEnv): void {
  if (typeof window !== 'undefined') {
    window.__env = env;
  }
  _env = env;
}

export function getEnv(): AppEnv {
  if (typeof window !== 'undefined' && window.__env) {
    return window.__env;
  }
  return _env;
}
